import Select from "react-select";
import AsyncSelect from "react-select/async";
import AsyncCreatableSelect from "react-select/async-creatable";
import {
  multiCheckClassName,
  multiCheckComponents,
  multiCheckGetOptionValue,
} from "./OptionSelect";

/**
 * Sélection de plusieurs choix.
 * Badges, croix, case à cocher et coche. Les sélecteurs métier
 * ne fournissent que les options et la valeur.
 *
 * Props en `any` volontairement : les callers mélangent Select / Async /
 * AsyncCreatable et un typage strict casse le pattern `SelectField = isMulti ? …`.
 */
export default function MultiCheckSelect({
  className = "",
  creatable = false,
  ...props
}: any) {
  const Component = creatable
    ? AsyncCreatableSelect
    : props.loadOptions
      ? AsyncSelect
      : Select;

  return (
    <Component
      {...props}
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      classNamePrefix="react-select"
      className={multiCheckClassName(className)}
      components={multiCheckComponents}
      getOptionValue={props.getOptionValue ?? multiCheckGetOptionValue}
    />
  );
}
